var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 810 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "European flag")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M0 0v1h0.5z",
    transform: "translate(0,-1)rotate(18)"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1,1)",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "rotate(72)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(144)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1,1)",
    xlinkHref: "#f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#039",
    width: 810,
    height: 540
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    transform: "scale(30)translate(13.5,9)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: -6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: -6
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(150)translate(0,6)rotate(66)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(120)translate(0,6)rotate(24)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(60)translate(0,6)rotate(12)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(30)translate(0,6)rotate(42)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "scale(-1,1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/eu.14f080b0e4ddde2c7d726bad3e4500d4.svg";
export { ForwardRef as ReactComponent };